import { render, staticRenderFns } from "./external-create-supplementary-agreement-termination.vue?vue&type=template&id=742a08e2&scoped=true&"
import script from "./external-create-supplementary-agreement-termination.vue?vue&type=script&lang=js&"
export * from "./external-create-supplementary-agreement-termination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742a08e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742a08e2')) {
      api.createRecord('742a08e2', component.options)
    } else {
      api.reload('742a08e2', component.options)
    }
    module.hot.accept("./external-create-supplementary-agreement-termination.vue?vue&type=template&id=742a08e2&scoped=true&", function () {
      api.rerender('742a08e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/externalPurchases/partials/external-create-supplementary-agreement-termination.vue"
export default component.exports